import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { desktopPathForMobilePath, useIsMobileDevice } from "./mobileDevice";

interface DesktopDeviceRouteProps {
  children: ReactNode;
}

/**
 * 모바일 라우트 가드. 데스크톱 기기가 `/mobile/*`에 있으면 대응하는 데스크톱 경로로
 * 돌려보냅니다. 이 가드가 없으면 모바일 라우트로 한 번 들어온 데스크톱 세션이
 * 빠져나올 경로 없이 갇힙니다.
 */
export default function DesktopDeviceRoute({
  children,
}: DesktopDeviceRouteProps) {
  const usesMobileLayout = useIsMobileDevice();
  const { pathname } = useLocation();

  if (!usesMobileLayout) {
    return <Navigate to={desktopPathForMobilePath(pathname)} replace />;
  }

  return <>{children}</>;
}
